import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EventClient, FileClient, RubricClient } from 'src/app/services/apis/web-api-client';
import { FileService } from 'src/app/services/file.service';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {
  news = [];
  rubrics = [];
  id = null;
  events = []; isLoading = true; selectedNews = null;

  constructor(
    private eventService: EventClient,
    private rubricService: RubricClient,
    private fileService: FileService,
    private activateRoute: ActivatedRoute
  ) {
    this.activateRoute.params.subscribe(params => {
      this.id = params['id']
    })
  }

  ngOnInit(): void {
    this.rubricService.getAll().subscribe(ru => {
      this.rubrics = ru;
      this.eventService.getAll().subscribe(data => {
        this.news = data;
        this.isLoading = false;

      });
    })

  }

  filterNews(rubric: string | null) {
    this.selectedNews = rubric;
    this.getNews();
  }


  getNews() {
    let result = this.news;
    if (this.selectedNews != null) {
      result = this.news.filter(x => x.rubricId === this.selectedNews);
    }

    return result;
  };

  getImage(id: string) {
    if (id) {
      return this.fileService.getDownloadUrl(id);

    } else {
      return "/assets/user.png"
    }
  }

  getRubrics() {
    return this.rubrics.filter(x => this.news.some(p => p.rubricId == x.id))
  }


  //scroll(id) {
  //  let el = document.getElementById("12");
  //  el.scrollIntoView();
  //}

  scroll(className: string): void {
    const elementList = document.getElementById(className);
    const element = elementList[0] as HTMLElement;
    element.scrollIntoView({ behavior: 'smooth' });
  }

  ngAfterContentInit(): void {
    //Called after ngOnInit when the component's or directive's content has been initialized.
    //Add 'implements AfterContentInit' to the class.
    // if (this.id !== null) this.scroll(this.id)
  }
}

